/**
 * Function to create a splash screen for iOS devices.
 * @param icon 
 * @param color 
 */
export default function useIosSplash (icon: string, color = 'white') {
  if (typeof icon !== 'string' || icon.length === 0) {
    throw new Error('Invalid icon URL provided')
  }
  
  const deviceWidth = screen.width
  const deviceHeight = screen.height
  const pixelRatio = window.devicePixelRatio || 1
  
  const canvas = document.createElement('canvas')
  const canvas2 = document.createElement('canvas')
  
  const ctx = canvas.getContext('2d')
  const ctx2 = canvas2.getContext('2d')
  
  const iconImage = new Image()
  iconImage.onerror = () => {
    throw new Error('Failed to load icon image')
  }
    
  iconImage.src = icon
  
  iconImage.onload = function () {
    const iconSizew = iconImage.width / (3 / pixelRatio)
    const iconSizeh = iconImage.height / (3 / pixelRatio)
  
    // Portrait canvas
    canvas.width = deviceWidth * pixelRatio
    canvas.height = deviceHeight * pixelRatio
  
    // Landscape canvas (flipped dimensions)
    canvas2.width = deviceHeight * pixelRatio
    canvas2.height = deviceWidth * pixelRatio
  
      ctx!.fillStyle = color
      ctx2!.fillStyle = color
  
      ctx!.fillRect(0, 0, canvas.width, canvas.height)
      ctx2!.fillRect(0, 0, canvas2.width, canvas2.height)
  
      const x = (canvas.width - iconSizew) / 2
      const y = (canvas.height - iconSizeh) / 2
      const x2 = (canvas2.width - iconSizew) / 2
      const y2 = (canvas2.height - iconSizeh) / 2
  
      ctx!.drawImage(iconImage, x, y, iconSizew, iconSizeh)
      ctx2!.drawImage(iconImage, x2, y2, iconSizew, iconSizeh)
  
      const imageDataURL = canvas.toDataURL('image/png')
      const imageDataURL2 = canvas2.toDataURL('image/png')
  
      const portraitLink = document.createElement('link')
      portraitLink.rel = 'apple-touch-startup-image'
      portraitLink.media = 'screen and (orientation: portrait)'
      portraitLink.href = imageDataURL
      document.head.appendChild(portraitLink)
  
      const landscapeLink = document.createElement('link')
      landscapeLink.rel = 'apple-touch-startup-image'
      landscapeLink.media = 'screen and (orientation: landscape)'
      landscapeLink.href = imageDataURL2
      document.head.appendChild(landscapeLink)
  }
}